<div class="card-header" *ngIf="client != null">
  <app-breadcrumb></app-breadcrumb>
  <div class="menu" [matMenuTriggerFor]="menu">
    <span class="material-icons white">more_vert</span>
  </div>
  <mat-menu #menu="matMenu" xPosition="before">
    <button mat-menu-item [routerLink]="'/bewind/'+client.id+'/bewerken'">
      <mat-icon>edit</mat-icon>
      <span>bewind bewerken</span>
    </button>
    <button mat-menu-item routerLink="/bewind/toevoegen">
      <mat-icon>person_add</mat-icon>
      <span>bewind aanmaken</span>
    </button>
  </mat-menu>
</div>

<div class="card-body">
  <div *ngIf="client != null">
    <app-list-account *ngIf="!isLoading" [client]="client"></app-list-account>
    <div class="spacer"></div>
    <div class="space-between flex unflex-on-phone">
      <button class="btn glasses btn-left" routerLink="importeren">banktransacties inlezen</button>
      <button class="btn plus" *ngIf="client.allowedToManuallyImport" routerLink="handmatig-rekening-toevoegen">bankrekening handmatig toevoegen</button>
      <button class="btn accent check btn-right btn-left" routerLink="rapportage">maak rapportage</button>
    </div>
    <app-task-list level="LOW" *ngIf="!isLoading" [clientId]="client.id"></app-task-list>
  </div>
</div>
